<template>
  <base-section id="platform-support">
    <base-section-heading
      color="grey lighten-2"
      v-bind:title="$t('Platform Support')"
    >{{ $t('Media Hoarder runs on all the major operating systems with x64 architecture_') }}</base-section-heading>

    <v-container>
      <v-row>
        <v-col v-for="card in cards" :key="card.title" cols="12" md="4" sm="6">
          <base-info-card v-bind="card" align="center" />
        </v-col>
      </v-row>

      <v-btn to="downloads" color="primary">{{ $t('TAKE ME TO THE DOWNLOADS') }}</v-btn>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "PlatformSupport",

  data: () => ({
    cards: [
      {
        icon: "mdi-microsoft-windows",
        title: "Windows",
        subtitle: "Bill_s very own",
        text: "As setup and portable for Windows 7/8/10",
        callout: "",
      },
      {
        icon: "mdi-linux",
        title: "Linux",
        subtitle: "Linus_ baby",
        text: "As setup (_deb or _rpm file), AppImage, Snap Package and portable",
        callout: "",
      },
      {
        icon: "mdi-apple",
        title: "MacOS",
        subtitle: "Steve_s heritage",
        text: "As Apple Disk Image (_dmg file)",
        callout: "",
      },
    ],
  }),
};
</script>
